// extracted by mini-css-extract-plugin
export var content = "_n2-1";
export var fullScreen = "_n2-0";